
export type AssetBundleState = 'waiting' | 'loading' | 'ready' | 'failed';

export interface AssetBundle {

    readonly state: AssetBundleState;

    load(): Promise<void>;
}

export const AssetBundle = {
    async loadAll(...bundles: AssetBundle[]) {
        for (const b of bundles) {
            await b.load();
        }
    }
};
